import React, { useContext, useEffect, useState } from "react";
import { StyleSheet, View, FlatList } from "react-native";

import { ListItemAccount, ListItemSeparator, NotificationListItem } from "../components/lists";
import colors from "../config/colors";
import Icon from "../components/Icon";
import Screen from "../components/Screen";
//import useAuth from "../auth/useAuth";
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
import AuthContext from "../auth/context";

function NotificationsScreen({ navigation }) {

  const { user, setUser } = useContext(AuthContext);
  var perfilUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
  const [ menuItems, setMenuItems ] =  useState([]) // para que es 

  useEffect(() => {
    if(JSON.parse(user).alias === 'notUser' ){
     // alert('notUser')
      navigation.navigate('ViewImage')
    }else{
      getNotificationType()
    }
  }, []);

  //-------------------------------------------------------------------
  //va al catalogo de notificationType por los tipos de notificación
  //------------------------------------------------------------------
  const getNotificationType = async () => {
     await fetch(connectionConfig.apiUrl+'/getNotificationType/', configurationPost)
     .then(response => response.json())
     .then(response => {
       setMenuItems(response.data)
     })
     .catch(err =>{
     console.log(':( review internet service -> /getNotificationType/', err )
     })
  }
  return (
    <Screen style={styles.screen}>
      <View style={styles.container}>
        <ListItemAccount
          titleRol={JSON.parse(user).userName}
          subTitle={JSON.parse(user).email}
          image={perfilUri + JSON.parse(user).userId + '_' + JSON.parse(user).userPhoto}
        />
      </View>
        <FlatList
          data={menuItems}
          keyExtractor={(menuItem) => menuItem.notificationTypeId.toString()}
          ItemSeparatorComponent={ListItemSeparator}
          renderItem={({ item, index }) => (
            <NotificationListItem
              title ={item.notificationTypeDesc}
              IconComponent={
                <Icon
                  iconFamily={item.iconFamily}
                  name={item.icon}
                  size ={item.size}
                  backgroundColor={item.backgroundColor}
                />
              }
              onPress={() =>{ 
                var type       = menuItems[index].notificationTypeDesc
                var iconFamily = menuItems[index].iconFamily
                var name       = menuItems[index].icon
                var size       = menuItems[index].size
                var backgroundColor = menuItems[index].backgroundColor
                console.log('type->',type )
                navigation.navigate(item.targetScreen, {type, iconFamily, name, size, backgroundColor} )

               }
              }
            />
          )}
        />
    </Screen>
  );
}

const styles = StyleSheet.create({
  screen: {
    backgroundColor: colors.light,
  },
  container: {
    marginVertical: 10,
  },
});

export default NotificationsScreen;
